import * as TYPES from './types';

export const externalSystemSelected = (selected) => ({
  type: TYPES.USER_SELECTED_EXTERNAL_SYSTEM,
  state: {
    userSelectedASystem: selected,
  },
});

export const externalSystemsLoaded = (systems) => ({
  type: TYPES.EXTERNAL_SYSTEMS_LOADED_SUCCESS,
  state: {
    externalSystems: systems,
  },
});

export const externalSystemsFailed = (message) => ({
  type: TYPES.EXTERNAL_SYSTEMS_LOADED_FAILED,
  error: message,
});
